(function () {

  'use strict';

  function pxRemoveIdpProvider($filter, toastr, IdpProviderService) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        callback: '&callback'
      },
      templateUrl: 'app/components/authenticationSettings/_removeIdpProvider/removeIdpProvider.template.html',
      link: function (scope) {
        scope.confirm = { delete: false };
        scope.idp = scope.context.idp.info ? scope.context.idp.info : scope.context.idp;

        scope.delete = function () {
          IdpProviderService.deleteDirectory(scope.idp._links.self.href).then(function () {
            toastr.success($filter('translate')('ChagesSaved'));
          }).catch(function () {
            toastr.error($filter('translate')('ERROR'));
          });
          scope.callback();
        };
      }
    };
  }

  pxRemoveIdpProvider.$inject = ['$filter', 'toastr', 'IdpProviderService'];

  angular
    .module('printix-admin')
    .directive('pxRemoveIdpProvider', pxRemoveIdpProvider);

})();
